<template>
  <VWidget
    v-if="enabled"
    :title="'iCount ' + $t('Documents')"
  >
    <div slot="widget-content">
      <v-list two-line>
        <v-flex v-if="!order.icount || order.icount.length === 0">
          <span>{{ $t('No documents to display') }}</span>
        </v-flex>

        <template v-for="(document, index) in order.icount">
          <v-list-tile
            :key="index"
          >
            <v-list-tile-content>
              <v-list-tile-title class="text-capitalize">
                <span>{{ $t('Reference') }}: {{ document.reference_type | type }} #{{ document.reference_number }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('Status') }}:</span>
                <span :class="statusClass(document)">
                  {{ document.status }}
                </span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="document.status === 'success'">
                <span> {{ $t('iCount number') }}: </span>
                <span class="font-weight-bold">{{ document.docnum }}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="document.status !== 'success'">
                <span :class="statusClass(document)">{{ $t(document.message) }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                v-if="document.link"
                :disabled="loading"
                icon
                color="primary"
                @click="print(document.link)"
              >
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                v-if="document.status !== 'success'"
                :disabled="loading && loadingDocument !== `${document.reference_type}-${document.reference_number}`"
                :loading="loadingDocument === `${document.reference_type}-${document.reference_number}`"
                icon
                color="secondary"
                @click="resend(document)"
              >
                <v-icon>autorenew</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </VWidget>

</template>
<script>
export default {
  name: 'OrderICountDocuments',

  filters: {
    type: function (arg) {
      return arg.replace('_', ' ')
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      loadingDocument: '',
      enabled: false
    }
  },

  async created () {
    const pluginsList = await this.$http.make('settings').getPluginsList()
    if (!pluginsList || pluginsList.length === 0) {
      this.enabled = false
      return
    }

    const plugin = pluginsList['futureecom/icount']

    if (!plugin) {
      this.enabled = false
      return
    }

    this.enabled = plugin.enabled
  },

  methods: {
    statusClass (document) {
      switch (document.status) {
        case 'success':
          return 'green--text'
        case 'warning':
          return 'warning--text'
        case 'error':
          return 'error--text'
        default:
          return ''
      }
    },

    print (link) {
      window.open(link)
    },

    resend (document) {
      this.loading = true
      this.loadingDocument = `${document.reference_type}-${document.reference_number}`
      this.order.request({
        method: 'POST',
        url: `${this.order.endpoint()}/icount/resend`,
        data: {
          number: document.reference_number,
          type: document.reference_type
        }
      }).then(() => {
        this.$toast(this.$t('Resending document to iCount'))
      }).finally(() => {
        this.$radio.$emit('renew-order')

        this.loading = false
        this.loadingDocument = ''
      })
    }
  }
}
</script>
